module.exports = __webpack_public_path__ + "img/add_circle_outline_purple.77520deb.svg";